var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.hidden)?_c('div',{staticClass:"generic-modal-container",class:{
    opened: !_vm.hidden,
    'bg-clip-padding bg-gray-50 backdrop-filter bg-opacity-50': !_vm.hidden,
    opaque: _vm.isOpaque
},on:{"click":_vm.bgClicked}},[_c('div',{staticClass:"generic-modal"},[_c('div',{staticClass:"overflow-y-scroll",staticStyle:{"height":"75vh"}},[(_vm.filesystemId)?_c('fs',{attrs:{"filesystem-id":_vm.filesystemId}}):_vm._e()],1)])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }